import AjaxUtils from '../../util/ajax_utils';

export const ApckAdminTrustSettings = {
    data: function () {
        return {
            loading: true,
            saving: false,
            trustScanEnabled: null,
            trustScanMaxConcurrent: null,
        };
    },
    computed: {
        enabledOptions: function () {
            return [
                { value: null, label: 'Use environment default' },
                { value: true, label: 'Enabled' },
                { value: false, label: 'Disabled' },
            ];
        },
        maxConcurrentStr: function () {
            return this.trustScanMaxConcurrent === null ? '' : String(this.trustScanMaxConcurrent);
        },
    },
    methods: {
        loadSettings: function () {
            var cmp = this;
            cmp.loading = true;
            AjaxUtils.ajax_get({
                url: '/admin/trust_settings/view',
                success: function (data) {
                    if (data.success) {
                        cmp.trustScanEnabled = data.data.trust_scan_enabled;
                        cmp.trustScanMaxConcurrent = data.data.trust_scan_max_concurrent;
                    }
                    cmp.loading = false;
                },
                fail: function () {
                    cmp.loading = false;
                },
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    flash_404_errors: false,
                    show_success_flash: false,
                },
            });
        },
        saveSettings: function () {
            var cmp = this;
            cmp.saving = true;
            AjaxUtils.ajax_post({
                url: '/admin/trust_settings/update',
                data: JSON.stringify({
                    trust_scan_enabled: cmp.trustScanEnabled,
                    trust_scan_max_concurrent: cmp.trustScanMaxConcurrent,
                }),
                success: function () {
                    cmp.saving = false;
                },
                fail: function () {
                    cmp.saving = false;
                },
                opts: {
                    dataType: 'json',
                    contentType: 'application/json',
                },
            });
        },
        setEnabled: function (value) {
            this.trustScanEnabled = value;
        },
        onMaxConcurrentInput: function (val) {
            this.trustScanMaxConcurrent = val === '' ? null : Number(val);
        },
    },
    mounted: function () {
        this.loadSettings();
    },
    template: `
        <ui-page title="Trust Monitor Settings" stickyTitle>
            <template #title-bar-buttons>
                <ui-button
                    label="Save"
                    iconLeft="fa-save"
                    :loading="saving"
                    :disabled="loading || saving"
                    @click.prevent="saveSettings"
                />
            </template>
            <template #content>
                <ui-layout direction="column" class="admin-trust-settings-content">
                    <ui-portlet-base
                        title="Scheduling"
                        :loading="loading"
                        titlePadding="md"
                    >
                        <ui-panel-base
                            direction="column"
                            justify="start"
                            align="start"
                            gap="4"
                            class="trust-settings-panel"
                        >
                            <ui-layout direction="column" gap="1" align="start" class="setting-group">
                                <ui-heading tag="span" size="sm" color="secondary">
                                    Enable Trust Scan Scheduling
                                </ui-heading>
                                <span class="setting-description">
                                    Controls whether the scheduler dispatches trust scans.
                                    When set to "Use environment default" the
                                    ENABLE_TRUST_SCAN_SCHEDULE environment variable is used.
                                </span>
                                <ui-layout gap="2" align="center" wrap class="setting-options">
                                    <ui-button
                                        v-for="opt in enabledOptions"
                                        :key="String(opt.value)"
                                        :label="opt.label"
                                        :type="trustScanEnabled === opt.value ? 'primary' : 'outline'"
                                        :disabled="loading"
                                        @click.prevent="setEnabled(opt.value)"
                                    />
                                </ui-layout>
                            </ui-layout>

                            <ui-input-text
                                label="Max Concurrent Trust Scans"
                                description="Maximum number of trust scans running at the same time across all organisations. Leave blank to use the TRUST_SCAN_MAX_CONCURRENT environment variable default."
                                type="number"
                                :min="1"
                                :max="200"
                                :disabled="loading"
                                class="scan-setting-number"
                                placeholder="env default"
                                :modelValue="maxConcurrentStr"
                                @update:modelValue="onMaxConcurrentInput"
                            />
                        </ui-panel-base>
                    </ui-portlet-base>

                    <ui-spinner :show="loading" theme="dark" />
                </ui-layout>
            </template>
        </ui-page>
    `,
};
